import { authenticatedFetch } from './auth.service';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://admin.goridesrw.com/api/remote";

const getOptionalAuthHeaders = () => {
  if (typeof window === 'undefined') {
    return {};
  }

  const token = window.localStorage.getItem('token');
  if (!token) {
    return {};
  }

  return {
    Authorization: `Bearer ${token}`,
  };
};

const getAvailableCars = async (params) => {
  const query = new URLSearchParams();
  if (params) {
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        query.append(key, params[key]);
      }
    });
  }

  const response = await fetch(`${BASE_URL}/public/cars?${query.toString()}`, {
    headers: {
      ...getOptionalAuthHeaders(),
    },
  });
  if (!response.ok) {
     throw new Error('Failed to fetch cars');
  }
  return response.json();
};

const getCarById = async (id) => {
  const response = await fetch(`${BASE_URL}/public/cars/${id}`);
  if (!response.ok) {
    throw new Error('Failed to fetch car details');
  }
  return response.json();
};

const getLandingPageData = async () => {
  const response = await fetch(`${BASE_URL}/public/landing-page`);
  if (!response.ok) {
    throw new Error('Failed to fetch landing page data');
  }
  return response.json();
};

const getAboutPageData = async () => {
  const response = await fetch(`${BASE_URL}/public/about-page`);
  if (!response.ok) {
    throw new Error('Failed to fetch about page data');
  }
  return response.json();
};

const getCategories = async () => {
  const response = await fetch(`${BASE_URL}/public/cars/categories`);
  if (!response.ok) {
    throw new Error('Failed to fetch categories');
  }
  return response.json();
};

const getCities = async () => {
  const response = await fetch(`${BASE_URL}/cities`);
  if (!response.ok) {
    throw new Error('Failed to fetch cities');
  }
  return response.json();
};

const subscribeToNewsletter = async (email) => {
  const response = await fetch(`${BASE_URL}/public/landing-page/subscribe`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email }),
  });
  if (!response.ok) {
    throw new Error('Failed to subscribe to newsletter');
  }
  return response;
};

const submitContactMessage = async (payload) => {
  const response = await fetch(`${BASE_URL}/public/landing-page/contact`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    throw new Error('Failed to submit contact message');
  }
  return response;
};

const submitTestimonial = async ({ quote, role, image }) => {
  const formData = new FormData();
  formData.append('quote', quote);
  if (role) {
    formData.append('role', role);
  }
  if (image) {
    formData.append('image', image);
  }

  const response = await authenticatedFetch(`${BASE_URL}/customer-testimonials`, {
    method: 'POST',
    body: formData,
  });

  const data = await response.json();
  if (!response.ok || data.action === 0) {
    throw new Error(data.message || 'Failed to submit testimonial');
  }
  return data;
};

const getDrivers = async (path) => {
  const response = await fetch(`${BASE_URL}/public/drivers${path ? `/${path}` : ''}`);
  if (!response.ok) throw new Error('Unable to load driver information');
  return response.json();
};

export const publicService = {
  getDrivers: () => getDrivers(''),
  getDriverDetails: (id) => getDrivers(`${encodeURIComponent(id)}/reviews`),
  getFeaturedDrivers: () => getDrivers('featured'),
  getHighestRatedDrivers: () => getDrivers('highest-rated'),
  getDriverReviews: (id) => getDrivers(`${encodeURIComponent(id)}/reviews`),
  getAvailableCars,
  getCarById,
  getLandingPageData,
  getAboutPageData,
  getCategories,
  getCities,
  subscribeToNewsletter,
  submitContactMessage,
  submitTestimonial,
};
